import { z } from 'zod';

export const SetupPortalStateSchema = z.object({
  recipient_name: z.string().nullable().optional(),
  department_name: z.string().nullable().optional(),
  offer_title: z.string().nullable().optional(),
  instruction_html: z.string().optional(),
  expires_at: z.string(),
  items: z.array(
    z.object({
      id: z.number(),
      kind: z.string(),
      label: z.string(),
      inline: z.boolean(),
      download_path: z.string().nullable().optional()
    })
  ),
  candidate_fields: z.record(z.string(), z.unknown()).optional()
});

export function parseSetupPortalState(data: unknown): z.infer<typeof SetupPortalStateSchema> {
  return SetupPortalStateSchema.parse(data);
}
